var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: "mensagem mensagem_cor-" + _vm.tipoDeMensagem + " u-sem-margem",
      attrs: { role: "alert" }
    },
    [
      _c("div", { staticClass: "mensagem__container-icone" }, [
        _vm.tipoDeMensagem == "sucesso"
          ? _c("i", { staticClass: "far fa-check-circle mensagem__icone" })
          : _vm._e(),
        _vm._v(" "),
        _vm.tipoDeMensagem == "erro"
          ? _c("i", { staticClass: "far fa-info-circle mensagem__icone" })
          : _vm._e(),
        _vm._v(" "),
        _vm.tipoDeMensagem == "atencao"
          ? _c("i", {
              staticClass: "far fa-exclamation-circle mensagem__icone"
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mensagem__conteudo" }, [
        _vm.tipoDeMensagem == "erro"
          ? _c("h2", { staticClass: "mensagem__titulo" }, [
              _vm._v("Parcelas em atraso")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "mensagem__texto" }, [
          _vm._v("\n            " + _vm._s(_vm.mensagem) + "\n        ")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c22dc89e", { render: render, staticRenderFns: staticRenderFns })
  }
}